import * as React from 'react';
import BattlesListPanel from '../components/BattlesListPanel';

export default function BattlesPage() {
    return <BattlesListPanel showTitle compact={false} />;
}
